import Axios from 'axios'
import config from '@/config/config.js'
// const baseUrl = 'http://192.168.119.122:8081'
const baseUrl = config.apiDomain.ALI + '/ext/core-util/jwt-token/api/jwt/'
const privateKeyUrl = baseUrl + 'getPrivateKey'
const publicKeyUrl = baseUrl + 'getPublicKeyByEuids'

// Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

export default {

  getPrivateKey (cb) {
    return new Promise((resolve, reject) => {
      Axios.get(privateKeyUrl).then(
        response => {
          cb(response)
          resolve()
        // console.log(response.status)
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        }
      )
    })
  },

  getPublicKeys (body, cb) {
    return new Promise((resolve, reject) => {
      Axios.post(publicKeyUrl, body).then(
        response => {
          cb(response)
          resolve()
        // console.log(response.status)
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        }
      )
    })
  }

}
